<template>
    <CallDialog v-if="visible" width="430px" :closable="false" :labelledby="'co_title' + _uid">
        <div class="co-body">
            <h3 :id="'co_title' + _uid" class="cdlg-title">Вы услышали человека?</h3>
            <p class="co-hint">Ответ обязателен для завершения исходящего звонка.</p>
            <div class="co-buttons">
                <button type="button" class="cdlg-btn cdlg-btn--yes" @click="$emit('answer', true)">Да</button>
                <button type="button" class="cdlg-btn cdlg-btn--no" @click="$emit('answer', false)">Нет</button>
            </div>
        </div>
    </CallDialog>
</template>

<script>
import CallDialog from "./CallDialog";

// Вопрос после исходящего звонка. Закрыть без ответа нельзя (Esc и клик мимо не работают):
// ответ уходит в calls.heard_human. Фокус не на кнопках, чтобы случайный Enter/пробел не записал «Да».
export default {
    name: "CallOutcomeDialog",
    components: {CallDialog},
    props: {
        visible: {type: Boolean, default: false},
    },
}
</script>

<style lang="scss" scoped>
.co-body {
    padding: 28px;
    text-align: center;
}
.cdlg-title {
    margin: 0 0 10px;
}
.co-hint {
    margin: 0;
    color: #afc0d5;
    font-size: 13px;
}
.co-buttons {
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-top: 22px;

    .cdlg-btn {
        min-width: 110px;
        min-height: 42px;
    }
}
</style>
